/* jshint esnext: true */
import AbstractModule from './AbstractModule';
import Dropdown from './Dropdown';

import { closeAllOverlays } from '../global/overlays';

export default class extends AbstractModule {
    constructor (options) {
        super(options);

        this.navMainOpenClass = 'has-nav-main-open';
        this.paneOpenClass = 'has-pane-open';
        this.maxWidth = 1199;
        this.minWidth = 1200;

        this.ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        this.$panes = this.$el.find('.js-nav-pane');

        if (this.ios) {
            this.$body.toggleClass('is-ios');
        }

        // Global events
        this.$document.on('toggleNav.Nav', (event, value) => {
            this.toggleNav(value);
        });
        this.$document.on('disablePanes.Nav', (event, value) => {
            this.disablePanes();
        });

        // Intra module events
        this.$el.on('click.Nav', '.js-nav-pane-toggle', (event) => {
            this.managePaneToggleClick(event);
        });

        // Constructing the Dropdown behaviour here so that we can better shape it
        // Mostly for maxWidth, so as to not have that in the markup
        this.dropdown = new Dropdown({
            $el: this.$el,
            el: this.el,
            'dropdown-mode': 'accordion',
            'dropdown-maxWidth': this.maxWidth
        });

        // Otherworldly events
        this.$document.on('click.Nav', '.js-toggle-nav', (event) => {
            this.toggleNav(false);
        });

        this.$document.on('keydown.Nav', (event) => {
            if (event.which === 27) {
                closeAllOverlays()
            }
        });

        // Scrolling anims
        this.isPreUnfurl = true;

        this.$window.on('scroll.Nav', () => {
            if (this.$window.scrollTop() <= 30) {
                if (this.isPreUnfurl) {
                    this.$body.removeClass('has-scrolled');
                } else {
                    this.$body.removeClass('has-scrolled');
                }
            } else {
                this.$body.addClass('has-scrolled');
            }
        });

        this.$window.trigger('scroll.Nav');

        window.setTimeout(() => {
            if (this.$window.scrollTop() <= 30) {
                this.isPreUnfurl = false;
            }
        }, 1200);
    }

    /**
     * @param  {object} event jQuery Event
     */
    managePaneToggleClick(event) {
        var $target = $(event.currentTarget);
        event.preventDefault();

        if (window.matchMedia('(min-width: ' + this.minWidth + 'px)').matches) {
            var $pane = $target.siblings('.js-nav-pane');
            var $parent = $target.parents('.js-nav-pane');

            // If $pane is defined, we're trying to display a specific pane
            if ($pane instanceof jQuery && $pane.length > 0) {
                $parent = false;
            // If not, we're trying to close one
            } else {
                $pane = false;
            }

            // Disable any open panes
            this.disablePanes();

            if ($pane) {
                this.activatePane($pane);
            }
        }
    }

    /**
     * Disable any open panes
     */
    disablePanes() {
        this.$panes.removeClass('is-active');
        this.$body.removeClass(this.paneOpenClass);
    }

    /**
     * Activate a specific pane
     * @param  {object}  $element  A jQuery node
     */
    activatePane($pane) {
        $pane.toggleClass('is-active');
        this.$body.addClass(this.paneOpenClass);
    }

    /**
     * Toggles class on body that determines if nav is visible or not
     * @param  boolean|mixed  State
     */
    toggleNav(state) {
        this.disablePanes();

        if (typeof state !== 'undefined' && typeof state === 'boolean') {
            this.$body.toggleClass(this.navMainOpenClass, state);
        } else {
            this.$body.toggleClass(this.navMainOpenClass);
        }
    }

    destroy() {
        this.dropdown.destroy();
        this.$body.removeClass('has-scrolled');
        this.$document.off('.Nav');
        this.$window.off('.Nav');
        this.$el.off('.Nav');
    }
}
